import { z } from 'zod';

export const healthDbSchema = z.object({
  message: z.string(),
  createdAt: z.date().optional().nullable()
});

export type HealthDbType = z.infer<typeof healthDbSchema>;
